import { configureStore, combineReducers } from '@reduxjs/toolkit'
import userReducer from '../features/user/userSlice'
import videoReducer from '../features/videos/videoState'
import audioReducer from '../features/audio/audioState'
import bookReducer from '../features/books/bookState'
import allContentReducer from '../features/allcontent/allContentState'
import adminAuthReducer from '../features/admin/adminSlice'

// Apply the persistReducer to each individual reducer

import { commentApi } from '../api/commentApi'

// Combine the persisted reducers
const rootReducer = combineReducers({
  user: userReducer,
  video: videoReducer,
  audio: audioReducer,
  books: bookReducer,
  allContents: allContentReducer,
  admin: adminAuthReducer,
  [commentApi.reducerPath]: commentApi.reducer,
})

// Configure the Redux store with the combined persisted reducers
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(commentApi.middleware),
})

// Export type definitions
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
